import { useMemo } from 'react';
import { GOOGLE_RCS } from '@rsos/capstone/src/constants/capabilities';
import { GOOGLE_RCS_PERMISSION } from '@rsos/capstone/src/constants/permissionNames';
import useHasCapability from '@rsos/hooks/useHasCapability';
import useHasPermission from '@rsos/hooks/useHasPermission';

const useHasAccessToGoogleRCS = () => {
  const hasGoogleRCSCapabilities = useHasCapability(GOOGLE_RCS);
  const hasGoogleRCSPermission = useHasPermission(GOOGLE_RCS_PERMISSION);
  const hasAccessToGoogleRCSFeature = useMemo(() => {
    return (
      !!hasGoogleRCSCapabilities?.hasCapability &&
      !!hasGoogleRCSPermission?.hasPermission
    );
  }, [hasGoogleRCSCapabilities, hasGoogleRCSPermission]);

  return hasAccessToGoogleRCSFeature;
};

export default useHasAccessToGoogleRCS;
